import React, {FC} from 'react';
import {BrowserRouter} from 'react-router-dom';

// import MUI.
import {CssBaseline} from '@mui/material';

import frLocale from 'date-fns/locale/fr';
import ruLocale from 'date-fns/locale/ru';
import deLocale from 'date-fns/locale/de';
import enLocale from 'date-fns/locale/en-US';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns'
// import library.





// import user Component
import Login from './layout/Login';
import TopMenu from './layout/TopMenu';
import BottomMenu from './layout/BottomMenu';
import Master from './layout/Master';

import BankUserChangePwdForm from './component/crm/BankUserChangePwdForm';

import { defaultPasswordChange } from './component/crm/model/BankUser';

// import user library
import { useUserStore } from './library/store';


// const localeMap = {
//   en: enLocale,
//   fr: frLocale,
//   ru: ruLocale,
//   de: deLocale,
// };

// const maskMap = {
//   fr: '__/__/____',
//   en: '__/__/____',
//   ru: '__.__.____',
//   de: '__.__.____',
// };

const getLocal = (lg : string) : Locale => {
  if(lg.startsWith('fr'))
    return frLocale;
  else if(lg.startsWith('en'))
    return enLocale;

  return frLocale;
}

const App: FC = () => {

  const {isAuthenticated,shouldResetPassword, currentUser} = useUserStore();

  const {} = currentUser;

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={getLocal(currentUser.language)} >
        <CssBaseline />
        <BrowserRouter >
        { isAuthenticated
          ? <TopMenu />
          : null //<LoginMenu />
        }
        
        { isAuthenticated
          ? shouldResetPassword? <BankUserChangePwdForm {...defaultPasswordChange} /> : <Master />
          : <Login login='' password='' language='fr-FR'  /> //<EnhancedTable /> // <Test />//
        }  

        { isAuthenticated
          ? null //<BottomMenu />
          : null
        }           
        </BrowserRouter>
      </LocalizationProvider>
    </>
  );
}

export default App;

